var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,attrs:{"data-preload":[_vm.$options.name]}},[_c('HeaderButton',{staticClass:"desktopLabel",attrs:{"modifiers":['headerButton'],"icon":{ name: 'wishlist_filled_heart', height: '21', width: '21' },"title":_vm.$t('header-wishlist-button.wishlist'),"label":_vm.$t('header-wishlist-button.wishlist'),"count":_vm.getWishlistProductCount,"href":_vm.isLoggedIn
        ? _vm.frontFacingPath('customer.shop.wishlist')
        : _vm.frontFacingPath('checkout.wishlist'),"toggle":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }